import axiosInstance from "./axiosInstance";
import {PrescriptionLogsData} from "../types/PrescriptionLogsData";
import {getParams} from "./util";

export const fetchPrescriptionLogs = async (params: any) => {
    const queryParams = getParams(params);
    const url = `/prescriptions/logs${queryParams}`;
    return axiosInstance.get<PrescriptionLogsData>(url)
        .then(response => response.data)
        .catch(error => console.error("ERROR", error))
}

export const downloadPrescriptionLogsExcel = async (params: any): Promise<any | void> => {
    const queryParams = getParams(params);
    return axiosInstance.get<any>(`/prescriptions/logs/excel${queryParams}`, {
        responseType: 'blob',
    })
        .then(response => response.data)
        .catch(error => error.response?.data || error)
}
